<app-top-bar />

<main class="shell">
  <router-outlet />
</main>

<footer class="sitefoot">
  <span>{{ 'shell.footer' | translate }}</span>
</footer>
